import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap";
import * as Yup from "yup";

import { CookiesKey, getCookie } from "src/globals";
import { User } from "src/sdk";
import { geUsersInitialValue, Users } from "src/sdk/models/Users";
import { ProfileService } from "src/services/ProfileService";

const service = new ProfileService();

export const EditBasicInfo = () => {
  const [profile, setProfile] = useState<Users>(geUsersInitialValue);
  const userJsonValues = getCookie(CookiesKey.USER_COOKIE);

  useEffect(() => {
    if (userJsonValues) {
      const user = JSON.parse(userJsonValues) as User;
      if (user?.id !== undefined) {
        service
          .getUserById(user.id)
          .then((response) => {
            setProfile(response.data.item);
          })
          .catch((error) => {
            console.error("API ERROR", error);
          });
      }
    }
  }, [userJsonValues]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: profile.firstName,
      lastName: profile.lastName,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please enter first name"),
      lastName: Yup.string().required("Please enter last name"),
    }),
    onSubmit: (values) => {
      const updatedUser: Users = {
        ...profile,
        firstName: values.firstName,
        lastName: values.lastName,
      };

      service
        .updateUser(updatedUser)
        .then((response) => {
          toast.success("Successfully updated!");
        })
        .catch((error) => {
          console.error("API ERROR", error);
        });
    },
  });

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="justify-content-center">
            <Col lg={4} md={5} className="col-xxl-4">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="auth-content my-auto">
                      <div className="text-center mb-2 p-5">
                        <h3>Edit User Info</h3>
                      </div>
                      <Form
                        className="custom-form mt-4 pt-2"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">First Name</Label>
                          <Input
                            name="firstName"
                            type="text"
                            className="form-control"
                            placeholder="Enter first name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.firstName || ""}
                            invalid={
                              validation.touched.firstName &&
                              !!validation.errors.firstName
                            }
                          />
                          {validation.touched.firstName &&
                            validation.errors.firstName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.firstName}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Last Name</Label>
                          <Input
                            name="lastName"
                            type="text"
                            className="form-control"
                            placeholder="Enter last name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.lastName || ""}
                            invalid={
                              validation.touched.lastName &&
                              !!validation.errors.lastName
                            }
                          />
                          {validation.touched.lastName &&
                            validation.errors.lastName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.lastName}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <button
                            className="btn btn-primary w-100 waves-effect waves-light"
                            style={{
                              border: 0,
                              backgroundColor: "#274755",
                              color: "#FFFFFF",
                            }}
                            type="submit"
                          >
                            Save
                          </button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditBasicInfo;
